import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceMonitoringOverviewService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-monitoring`;

    static getInstance() {
        if (!ComplianceMonitoringOverviewService.instance) {
            ComplianceMonitoringOverviewService.instance = new ComplianceMonitoringOverviewService();
        }

        return ComplianceMonitoringOverviewService.instance;
    }

    async fetchOverviewData(params = {}) {
        const response = await axios.get(
            `${this.resource}/overview`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
}
